export default (requirePhoneNumber) => ({
    email: {
        presence: true,
        type: "string",
        format: {
            pattern: /^[\w-.+]+@([\w-]+\.)+[\w-]{2,4}$/,
        },
    },
    name: {
        length: { minimum: 2 },
        presence: true,
        type: "string",
    },
    password: {
        conditionalPresenceMatchAll: [
            { field: "singleUsePassword", value: true, inverted: true },
        ],
        type: "string",
        checkPassword: {
            pattern: /^.{8,}$/,
            message: "must be at least 8 characters long",
        },
    },
    lastLogin: {
        type: "Dayjs",
    },
    mobileNumber: {
        presence: requirePhoneNumber,
        type: "string",
        format: requirePhoneNumber
            ? {
                pattern: /^(?:[ \-]?\d){9,15}([ \-])?$/,
                message: "^Please enter a valid phone number.",
            }
            : undefined,
    },
    singleUsePassword: {
        type: "boolean",
    },
    resetId: {
        type: "string",
    },
});
